// Import from the client-safe subpath, NOT the '@warike/api' barrel: the barrel
// re-exports the tRPC server (appRouter → initTRPC.create()), which throws when
// evaluated in the browser. `@warike/api/schemas` pulls in zod only.
import { credentialsSchema, signUpSchema } from '@warike/api/schemas'
import { z } from 'zod'

/**
 * Client-side form schemas. They REUSE the server's shared schemas
 * (@warike/api) as the single source of truth for email/password rules, and add
 * only what is form-specific — here, the password-confirmation match, which the
 * server never sees.
 */
export const loginFormSchema = credentialsSchema

export const signUpFormSchema = signUpSchema
  .extend({ confirm: z.string().min(1, 'Confirm your password.') })
  .refine((data) => data.password === data.confirm, {
    message: 'Passwords do not match.',
    path: ['confirm'],
  })

/** First Zod issue message, for a single-line inline form error. */
export function firstFormIssue(error: z.ZodError): string {
  return error.issues[0]?.message ?? 'Please check your details.'
}
